import type { ReactNode } from 'react';

export const symbol_settings_ethernet: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M834-480 659-657q-8-9-8.5-21t8.5-21q9-9 21-9t21 9l198 198q5 5 7 10t2 11q0 6-2 11t-7 10L701-261q-9 9-21 9t-21-9q-9-9-8.5-21t8.5-21l175-177Zm-708 0 175 177q8 9 8.5 21t-8.5 21q-9 9-21 9t-21-9L61-459q-5-5-7-10t-2-11q0-6 2-11t7-10l198-198q9-9 21-9t21 9q9 9 8.5 21t-8.5 21L126-480Zm169.5 24.5Q285-466 285-480t10.5-24.5Q306-515 320-515t24.5 10.5Q355-494 355-480t-10.5 24.5Q334-445 320-445t-24.5-10.5Zm160 0Q445-466 445-480t10.5-24.5Q466-515 480-515t24.5 10.5Q515-494 515-480t-10.5 24.5Q494-445 480-445t-24.5-10.5Zm160 0Q605-466 605-480t10.5-24.5Q626-515 640-515t24.5 10.5Q675-494 675-480t-10.5 24.5Q654-445 640-445t-24.5-10.5Z"
		/>
	</svg>
);
